const initialState = {
	customerSurvey: null,
}

export const CustomerSurveyReducer = (state = initialState, { type, payload = {} }) => {
	switch (type) {
		case 'CUSTOMER_SURVEY': {
			// console.log({
			// 	reducer: {
			// 		type: type,
			// 		payload: payload.data.data.items
			// 	}
			// })
			return {
				...state,
				customerSurvey: payload.data.success ? { ...payload.data.data } : null
			}
		}
		default: return state
	}
}